export const validFileExtensions = [
  'csv',
  'doc',
  'docx',
  'gif',
  'jpg',
  'jpeg',
  'pdf',
  'png',
  'tif',
  'tiff',
  'txt',
  'xls',
  'xlsx'
]
